import React, { useState, useEffect, useRef } from "react";
import { getLoggedInUser } from "../helpers";
import { alertActions } from "../redux/alert/actions";
import { Container, Col, Row, Alert, Button } from "reactstrap";
import { AvForm, AvField, AvGroup } from 'availity-reactstrap-validation';
import { connect } from "react-redux";
import { betSlipService } from '../redux/betslip/services';
import swal from 'sweetalert';
import Loader from "./Loader/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

const ChangePassword = (props) => {
    const [user, setUser] = useState(getLoggedInUser());
    const [isLoading, setIsLoading] = useState(false);
    const [resMessage, setResMessage] = useState('');
    const [right, setRight] = useState(false);
    const [wrong, setWrong] = useState(false);
    const formRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        // Perform any necessary setup here
    }, []);

    const onDismiss = () => {
        setRight(false);
        setWrong(false);
    };

    const handleValidSubmit = (event, values) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to change the password?",
            icon: "warning",
            buttons: ["Cancel", "Confirm"],
        }).then((confirmed) => {
            if (confirmed) {
                setIsLoading(true);
                const formData = new FormData();
                formData.append('guid', user.guid);
                formData.append('currentPassword', values.old_password);
                formData.append('newPassword', values.password);
                formData.append('confirmPassword', values.password);

                betSlipService.changePassword(formData)
                    .then((res) => {
                        if (res.message && res.data === 1) {
                            setWrong(false);
                            setRight(true);
                            setResMessage(res.message);
                            formRef.current.reset();
                        } else {
                            setWrong(true);
                            setResMessage(res.message);
                        }
                    })
                    .catch((error) => {
                        console.error('Error changing password:', error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        });
    };

    const onTrigger = (event) => {
        props.parentCallback(true);
    };

    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div className="account-pages">
                <section className="dashboard-section padding-top padding-bottom">
                    <Container>
                        <Row>
                            <Col className="col-lg-12 col-md-12">
                                <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                                    <h4 className="title m-0">Menu</h4>
                                    <div
                                        className="user-toggler"
                                        onClick={onTrigger}
                                    >
                                        <i className="las la-sliders-h"></i>
                                    </div>
                                </div>
                                <div className="custom--card card--lg">
                                    <div className="card--body">
                                        <Row>
                                            <Col md={12}>
                                                <Alert color={resMessage === 'Password updated successfully.' ? 'success' : 'danger'} isOpen={wrong}>
                                                    {resMessage}
                                                </Alert>
                                                <Alert color="success" isOpen={right}>
                                                    {resMessage}
                                                </Alert>
                                            </Col>
                                        </Row>
                                        <AvForm onValidSubmit={handleValidSubmit} ref={formRef} className='mt-3 frm_change py-l-r'>
                                            <div className="col-md-6 col-sm-12 text---black mb-1">{t('userProfile.changePassword.currentPassword')}</div>
                                            <div className="col-md-6 mb-3">
                                                <AvField
                                                    className="form-control form--control2 style-two"
                                                    type="password" name="old_password"
                                                    placeholder={t('userProfile.changePassword.currentPassword')}
                                                    required
                                                    validate={{
                                                        required: { value: true, errorMessage: t('userProfile.changePassword.pleaseEnterCurrentPassword') }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12 text---black mb-1">{t('userProfile.changePassword.newPassword')}</div>
                                            <div className="col-md-6 mb-3">
                                                <AvField
                                                    id="password"
                                                    type="password"
                                                    className="form-control form--control2 style-two"
                                                    name="password"
                                                    placeholder={t('userProfile.changePassword.newPassword')}
                                                    validate={{
                                                        required: { value: true, errorMessage: t('userProfile.changePassword.pleaseEnterNewPassword') }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12 text---black mb-1">{t('userProfile.changePassword.confirmPassword')}</div>
                                            <div className="col-md-6 mb-3">
                                                <AvGroup>
                                                    <AvField
                                                        className="form-control form--control2  style-two"
                                                        type="password"
                                                        name="cnfm_password"
                                                        id="cnfm_password"
                                                        placeholder={t('userProfile.changePassword.confirmPassword')}
                                                        validate={{
                                                            required: { value: true, errorMessage: t('userProfile.changePassword.pleaseConfirmPassword') },
                                                            match: { value: 'password', errorMessage: t('userProfile.changePassword.confirmPasswordMismatch') },
                                                        }}
                                                    />
                                                </AvGroup>
                                            </div>
                                            <div className="col-md-12 col-sm-12 center">
                                                <button className="cstm_btn2 active mt-3">{t('userProfile.changePassword.save')}</button>
                                                {/* <button className="cstm_btn w-50 btn--round active mt-3">Save</button> */}
                                            </div>
                                        </AvForm>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    const { user } = state.Auth;
    return { user };
};

export default connect(mapStateToProps)(ChangePassword);
